import { OptimizeResumeVisual } from './OptimizeResumeVisual'
export default OptimizeResumeVisual
